(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["campaign-carousel"] && !Shopify.designMode) return;
  try {
    
class CampaignCarousel {
  constructor(section) {
    this.section = section;
    this.viewport = section.querySelector('[data-carousel-viewport]');
    this.slides = [...section.querySelectorAll('.campaign-carousel__slide')];
    this.prevBtn = section.querySelector('[data-prev]');
    this.nextBtn = section.querySelector('[data-next]');
    this.currentEl = section.querySelector('[data-current]');
    this.totalEl = section.querySelector('[data-total]');
    this.progressFill = section.querySelector('[data-progress-fill]');
    this.autoplayTimer = null;
    this.autoplayStartTimeout = null;
    this.mqlReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (!this.viewport || this.slides.length === 0) return;

    this.bind();
    this.update();
    this.queueAutoplayStart();
  }

  bind() {
    this.onScroll = this.update.bind(this);
    this.onPrev = () => this.goTo(this.getActiveIndex() - 1);
    this.onNext = () => this.goTo(this.getActiveIndex() + 1);
    this.onResize = () => {
      this.update();
      this.stopAutoplay();
      this.queueAutoplayStart();
    };
    this.onMouseEnter = () => this.stopAutoplay();
    this.onMouseLeave = () => this.queueAutoplayStart();
    this.onFocusIn = () => this.stopAutoplay();
    this.onFocusOut = () => this.queueAutoplayStart();
    this.onVisibilityChange = () => {
      if (document.hidden) {
        this.stopAutoplay();
      } else {
        this.queueAutoplayStart();
      }
    };
    this.onWindowLoad = () => {
      this.update();
      this.queueAutoplayStart();
    };
    this.onPageShow = () => {
      this.update();
      this.queueAutoplayStart();
    };

    this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
    this.prevBtn?.addEventListener('click', this.onPrev);
    this.nextBtn?.addEventListener('click', this.onNext);
    window.addEventListener('resize', this.onResize);
    window.addEventListener('load', this.onWindowLoad);
    window.addEventListener('pageshow', this.onPageShow);
    this.section.addEventListener('mouseenter', this.onMouseEnter);
    this.section.addEventListener('mouseleave', this.onMouseLeave);
    this.section.addEventListener('focusin', this.onFocusIn);
    this.section.addEventListener('focusout', this.onFocusOut);
    document.addEventListener('visibilitychange', this.onVisibilityChange);
  }

  getActiveIndex() {
    const viewportRect = this.viewport.getBoundingClientRect();
    let nearest = 0;
    let minDiff = Infinity;

    this.slides.forEach((slide, index) => {
      const slideRect = slide.getBoundingClientRect();
      const diff = Math.abs(slideRect.left - viewportRect.left);
      if (diff < minDiff) {
        minDiff = diff;
        nearest = index;
      }
    });

    return nearest;
  }

  getTargetScrollLeft(slide) {
    const viewportRect = this.viewport.getBoundingClientRect();
    const slideRect = slide.getBoundingClientRect();
    return this.viewport.scrollLeft + (slideRect.left - viewportRect.left);
  }

  goTo(index) {
    if (!this.slides.length) return;

    if (index < 0) index = this.slides.length - 1;
    if (index >= this.slides.length) index = 0;

    const slide = this.slides[index];
    const left = this.getTargetScrollLeft(slide);

    this.viewport.scrollTo({
      left,
      behavior: 'smooth'
    });
  }

  getNextIndex() {
    const current = this.getActiveIndex();
    const next = current + 1;
    return next >= this.slides.length ? 0 : next;
  }

  update() {
    const index = this.getActiveIndex();

    if (this.currentEl) this.currentEl.textContent = index + 1;
    if (this.totalEl) this.totalEl.textContent = this.slides.length;
    if (this.progressFill) {
      this.progressFill.style.width = `${((index + 1) / this.slides.length) * 100}%`;
    }
  }

  isScrollable() {
    return this.viewport.scrollWidth > this.viewport.clientWidth + 4;
  }

  canAutoplay() {
    if (window.innerWidth <= 749) return false;
    if (this.mqlReducedMotion.matches) return false;
    if (document.hidden) return false;
    if (this.section.dataset.autoplay !== 'true') return false;
    if (this.slides.length <= 1) return false;
    if (!this.isScrollable()) return false;
    return true;
  }

  queueAutoplayStart() {
    this.stopAutoplay();
    if (this.autoplayStartTimeout) {
      clearTimeout(this.autoplayStartTimeout);
      this.autoplayStartTimeout = null;
    }

    this.autoplayStartTimeout = window.setTimeout(() => {
      this.startAutoplay();
    }, 250);
  }

  startAutoplay() {
    if (!this.canAutoplay()) return;

    const speed = Number(this.section.dataset.autoplaySpeed || 5000);

    this.stopAutoplay();

    this.autoplayTimer = window.setInterval(() => {
      this.goTo(this.getNextIndex());
    }, speed);
  }

  stopAutoplay() {
    if (this.autoplayStartTimeout) {
      clearTimeout(this.autoplayStartTimeout);
      this.autoplayStartTimeout = null;
    }

    if (this.autoplayTimer) {
      window.clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }

  destroy() {
    this.stopAutoplay();
    this.viewport?.removeEventListener('scroll', this.onScroll);
    this.prevBtn?.removeEventListener('click', this.onPrev);
    this.nextBtn?.removeEventListener('click', this.onNext);
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('load', this.onWindowLoad);
    window.removeEventListener('pageshow', this.onPageShow);
    this.section.removeEventListener('mouseenter', this.onMouseEnter);
    this.section.removeEventListener('mouseleave', this.onMouseLeave);
    this.section.removeEventListener('focusin', this.onFocusIn);
    this.section.removeEventListener('focusout', this.onFocusOut);
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
  }
}

const instances = new Map();

function initCarouselRoot(root) {
  if (!root || instances.has(root)) return;
  const instance = new CampaignCarousel(root);
  instances.set(root, instance);
}

function destroyCarouselRoot(root) {
  if (!root) return;
  const instance = instances.get(root);
  if (instance) {
    instance.destroy();
    instances.delete(root);
  }
}

function initAllCarousels() {
  document.querySelectorAll('.campaign-carousel').forEach(initCarouselRoot);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllCarousels);
} else {
  initAllCarousels();
}

window.addEventListener('load', initAllCarousels);
window.addEventListener('pageshow', initAllCarousels);

document.addEventListener('shopify:section:load', (event) => {
  const root = event.target.querySelector('.campaign-carousel');
  initCarouselRoot(root);
});

document.addEventListener('shopify:section:unload', (event) => {
  const root = event.target.querySelector('.campaign-carousel');
  destroyCarouselRoot(root);
});

document.addEventListener('shopify:block:select', (event) => {
  const section = event.target.closest('.shopify-section');
  const root = section?.querySelector('.campaign-carousel');
  const instance = root ? instances.get(root) : null;
  const slide = event.target.closest('.campaign-carousel__slide');

  if (!instance || !slide) return;

  instance.stopAutoplay();
  instance.viewport.scrollTo({
    left: instance.getTargetScrollLeft(slide),
    behavior: 'smooth'
  });
});

  } catch(e) { console.error(e); }
})();
})();
